// Min number of characters required for all notes fields
export const minCharacters = 10;

// Number to divide the zoom bar by for the zoom - and + buttons
export const zoomLevels = 5;

// Default maxZoom before a size is selected
export const defaultMaxZoom = 10;

// Magic number that helps set the width of the arranger in order to prevent the height from being too tall
export const magicRatioNum = 135;

// Fake proof loading time min and max
export const proofLoadingTimes = {
  min: 0.7,
  max: 1.6,
};
